/**
 * @hooks
 * @title
 * @description
 * @properties
 * @author 2034263
 * @history
 *   - [2025-09-30] 초기 작성
 */

import { useCallback } from 'react';
import { MutateOptions } from 'react-query';
import { UseRestPostMutationOptions } from 'scbk-services/http';
import { CommonRestResponse } from 'scbk-services/types/http/axios-extension';
import { AutUsrLgnInquirySessionInfoRequest, AutUsrLgnInquirySessionInfoResponse } from '../types';
import {
    useAutUsrLgnExtendSession,
    useAutUsrLgnInquirySessionInfo,
    useAutUsrLgnLogout,
} from './api';

interface Props {
    onExecuteLogoutOptions?: UseRestPostMutationOptions<null, null, CommonRestResponse<null>>;
    onExtendSessionOptions?: UseRestPostMutationOptions<null, null, CommonRestResponse<null>>;
    onInquirySessionInfoOptions?: UseRestPostMutationOptions<
        AutUsrLgnInquirySessionInfoRequest,
        AutUsrLgnInquirySessionInfoResponse,
        CommonRestResponse<AutUsrLgnInquirySessionInfoResponse>
    >;
}

export const useSessionService = (props?: Props) => {
    const { mutateAsync: logout } = useAutUsrLgnLogout({
        skipUnauthorizedErrorHandler: true,
        skipForbiddenErrorHandler: true,
        ...props?.onExecuteLogoutOptions,
    });
    const { mutateAsync: extendSession } = useAutUsrLgnExtendSession({
        skipLoading: true,
        skipUnauthorizedErrorHandler: true,
        skipForbiddenErrorHandler: true,
        ...props?.onExtendSessionOptions,
    });
    const { request: inquirySessionInfo } = useAutUsrLgnInquirySessionInfo({
        skipLoading: true,
        skipUnauthorizedErrorHandler: true,
        skipForbiddenErrorHandler: true,
        ...props?.onInquirySessionInfoOptions,
    });

    // 세션파기 API
    const executeLogout = useCallback(
        (
            options?:
                | MutateOptions<CommonRestResponse<null>, CommonRestResponse<null>, null, unknown>
                | undefined,
        ) => {
            return logout(null, options);
        },
        [],
    );

    // 세션연장 API
    const executeExtendSession = useCallback(
        (
            options?:
                | MutateOptions<CommonRestResponse<null>, CommonRestResponse<null>, null, unknown>
                | undefined,
        ) => {
            return extendSession(null, options);
        },
        [],
    );

    // 세션조회 API
    const getSessionInfo = useCallback(
        (
            param: AutUsrLgnInquirySessionInfoRequest,
            options?:
                | UseRestPostMutationOptions<
                      AutUsrLgnInquirySessionInfoRequest,
                      AutUsrLgnInquirySessionInfoResponse,
                      CommonRestResponse<AutUsrLgnInquirySessionInfoResponse>
                  >
                | undefined,
        ) => {
            let res = undefined;
            try {
                res = inquirySessionInfo(param, options);
            } catch (error) {
                console.error('useSessionService > getSessionInfo - error : ', error);
            }
            return res;
        },
        [],
    );

    return {
        executeLogout,
        executeExtendSession,
        getSessionInfo,
    };
};
